export async function decryptData(encryptedData: string, keyHex: string) {
  const [ivBase64, encryptedBase64, authTagBase64] = encryptedData.split(":");

  const iv = Uint8Array.from(atob(ivBase64), (c) => c.charCodeAt(0));
  const data = Uint8Array.from(atob(encryptedBase64), (c) => c.charCodeAt(0));
  const authTag = Uint8Array.from(atob(authTagBase64), (c) => c.charCodeAt(0));

  // Helper to convert hex string to Uint8Array
  function hexStringToUint8Array(hexString: string): Uint8Array {
    if (hexString.length % 2 !== 0) {
      throw new Error("Invalid hex string");
    }
    const array = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
      array[i / 2] = parseInt(hexString.substr(i, 2), 16);
    }
    return array;
  }

  const keyBuffer = hexStringToUint8Array(keyHex);

  const combinedData = new Uint8Array(data.length + authTag.length);
  combinedData.set(data);
  combinedData.set(authTag, data.length);

  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  try {
    const decrypted = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv,
        tagLength: 128,
      },
      cryptoKey,
      combinedData
    );

    const decoder = new TextDecoder();
    return JSON.parse(decoder.decode(decrypted));
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
}
